import React from 'react'
import { FlexCenter, Padding } from '../../../styles/CommonStyles'
import { SOCKET_URL } from '../../../core/constants/urls'
import { BuyIcon, SellIcon, TextWithMargin } from '../../../styles/OrdersStyle'
import { ItemRow } from '../../../styles/newStyles/MobileModal.styled'
import { DetailText } from '../../../styles/TransactionHistoryStyles'
import { formatDate, formatNumber } from '../../../core/utils/common'
import Text from '../../../core/utils/Text'
import { useMainContext } from '../../../core/contexts/main'

const OtcHistoryDetailsModal = ({ data, onClose }) => {
    const {
        main: { lang },
    } = useMainContext()

    return (
        <div>
            <FlexCenter width='100%'>
                <Padding padding='10px 0' style={{ borderBottom: '1px solid #ffffff15' }}>
                    <DetailText>
                        <Text tid='see-details' />
                    </DetailText>
                </Padding>
            </FlexCenter>

            <div className='p-2 bg-slate-100 dark:bg-transparent rounded-xl mb-4'>
                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='coin' className='text-pcolor-light text-sm' />
                    <FlexCenter className='gap-2'>
                        <img
                            src={`${SOCKET_URL}assets/icon/${data.coin}.png`}
                            alt={data.coin}
                            width={20}
                            height={20}
                        />
                        <span>{data.coin?.toUpperCase()}</span>
                    </FlexCenter>
                </ItemRow>

                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='amount' className='text-pcolor-light text-sm' />
                    <span>{formatNumber(data.amount)}</span>
                </ItemRow>

                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='wage' className='text-pcolor-light text-sm' />
                    <span>
                        {`${formatNumber(data.wage)} (${data.type === 'sell' ? 'IRT' : data.coin?.toUpperCase()})`}
                    </span>
                </ItemRow>

                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='unitPrice' className='text-pcolor-light text-sm' />
                    <span>{data.priceUnit ? formatNumber(data.priceUnit) : '--'}</span>
                </ItemRow>

                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='totalPrice' className='text-pcolor-light text-sm' />
                    <span>{data.price ? formatNumber(data.price) : '--'}</span>
                </ItemRow>

                <ItemRow className='dark:border-b dark:border-card-border'>
                    <Text tid='transactionType' className='text-pcolor-light text-sm' />
                    <FlexCenter className='gap-1'>
                        {data.type === 'buy' ? <BuyIcon /> : <SellIcon />}
                        <TextWithMargin type={data.type}>
                            <Text tid={data.type} />
                        </TextWithMargin>
                    </FlexCenter>
                </ItemRow>

                <ItemRow>
                    <Text tid='date-time' className='text-pcolor-light text-sm' />
                    <div className='flex flex-col gap-1'>
                        <span>{formatDate(data.createdAt, 'date', lang === 'en' ? 'en-US' : 'fa-IR')}</span>
                        <span>{formatDate(data.createdAt, 'time', lang === 'en' ? 'en-US' : 'fa-IR')}</span>
                    </div>
                </ItemRow>
            </div>
        </div>
    )
}

export default OtcHistoryDetailsModal
